import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next';

import routes from '../../Constants/routes'

import LeadsList from '../../Components/Leads/LeadsList'
import SelectedLeadsButton from '../../Components/Leads/SelectedLeadsButton'
import CloseModal from '../../Components/Leads/CloseModal'

import leadActionsImp from '../../Actions/leadActions'
import commonActionsImp from '../../Actions/commonActions'
import NewLeadsModal from '../../Components/Leads/NewLeadsModal';
import { DefaultCard } from "../../Components/Card/Card";

function MyOpenLeadsContainer ({activeLead, moveToDetails}) {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const commonActions = bindActionCreators(commonActionsImp, dispatch);
    const leadActions = bindActionCreators(leadActionsImp, dispatch);
    const leads = useSelector(state => state.LeadsReducer.myLeads)
    const closedLeads = useSelector(state => state.LeadsReducer.myClosedLeads);
    const selectedLeads = useSelector(state => state.LeadsReducer.selectedLeads);
    const leadTypes = useSelector(state => state.LeadsReducer.leadTypes);

    const [showCloseModal, setShowCloseModal] = useState(false);
    const [showNewLeadModal, setShowNewLeadModal] = useState(false);
    const [filterStatement, setFilterStatement] = useState(localStorage.getItem("leadTypeFilter"));

    function sortListByKey(listName, list) {
        return key => {
            commonActions.sortListByKey(list, key, listName);
        }
    }

    const onLineSelect = (leadId) => {
        const lead = leads.find(item => item.id === leadId);
        leadActions.selectLead(lead, selectedLeads);
    }

    const deselectAll = () => {
        leadActions.clearSelectedLeads();
    }

    const toggleModal = (modalName) => {
        if (modalName === "showCloseModal") setShowCloseModal(v => !v);
        if (modalName === "showNewLeadModal") setShowNewLeadModal(v => !v);
    }

    const onCloseClick = (isModal) => {
        if (isModal)
            setShowCloseModal(() => false);
    }

    const onClosedLeadsClick = () => {
        setFilterStatement("closedLeads");
        leadActions.getMyClosedLeads();
    }

    const filterLeads = (filterStatement) => {
        localStorage.setItem("leadTypeFilter", filterStatement);
        setFilterStatement(() => filterStatement);
    }

    const renderLeadsCounter = (leads) => {
        const countLeads = leads.length;
        if (countLeads > 0)
            return <span className="badge badge-default">{countLeads}</span>
    }

    if (!leads) {
        return null;
    }

    const filter = filterStatement;

    let myLeads = leads;
    let filterOpenLeads = false;
    let filterClosedLeads = false;
    let filterAssignedLeads = false;

    const assignedLeads = leads.filter(lead => !lead.isClosed && lead.lastAction === "Assigned");
    const openLeads = leads.filter(lead => !lead.isClosed && lead.lastAction !== "Assigned");

    if (filter === "openLeads" || !filter) {
        myLeads = openLeads
        filterOpenLeads = true;
    }

    if (filter === "closedLeads") {
        myLeads = closedLeads ?? []
        filterClosedLeads = true;
    }

    if (filter === "assignedLeads") {
        myLeads = assignedLeads
        filterAssignedLeads = true;
    }

    return <>
        {showCloseModal && <CloseModal multiple={true} onClose={() => toggleModal("showCloseModal")}
                                       onSave={() => onCloseClick(true)}/>}
        {showNewLeadModal && <NewLeadsModal multiple={true} onClose={() => toggleModal("showNewLeadModal")}
                                            onSave={leadActions.assingLeads} leadTypes={leadTypes}/>}

        <DefaultCard title={t('myopenleadscontainer.myleads')}>
            <Link to={routes.leadsMySettings}><span
                className="vismaicon vismaicon-settings pull-right margin-right cursorpointer"
                title={t('myopenleadscontainer.settings')}></span></Link>

            <div className='mb-10'>
                <button className={filterAssignedLeads ? "btn btn-default active" : "btn btn-default"}
                        onClick={() => filterLeads("assignedLeads")}>{t('myopenleadscontainer.assigned')} {renderLeadsCounter(assignedLeads)}</button>
                <button className={filterOpenLeads ? "btn btn-default active" : "btn btn-default"}
                        onClick={() => filterLeads("openLeads")}>{t('myopenleadscontainer.openleads')} {renderLeadsCounter(openLeads)}</button>
                <button className={filterClosedLeads ? "btn btn-default active" : "btn btn-default"}
                        onClick={() => onClosedLeadsClick()}>{t('myopenleadscontainer.closedleads')}</button>
                <div className='float-right'>
                    <button type="button"
                            className={`btn btn-primary no-margin`}
                            onClick={() => toggleModal("showNewLeadModal")}>{t('myopenleadscontainer.newleads')}</button>
                    <div className="clearfix"></div>
                    <SelectedLeadsButton selectedLeads={selectedLeads} deselectAll={deselectAll}
                                         toggleModal={toggleModal}/>
                </div>
            </div>
            <div className='clearfix'></div>
            <div>
                {myLeads.length < 1 && <p>{t('myopenleadscontainer.noentriesfound')}</p>}
                {myLeads.length > 0 && <LeadsList styles={{height: "917px"}} leads={myLeads} activeLead={activeLead}
                                                   onLineSelect={onLineSelect} moveToDetails={moveToDetails}
                                                   selectedLeads={selectedLeads}
                                                   sortListByKey={sortListByKey("myLeads", leads)}/>}
            </div>
        </DefaultCard>
    </>
}

export default MyOpenLeadsContainer;